import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '@rocksoft/shared/toast';
import { AppleApplicationsService } from '../../../shared/services/apple-application.service';
import { UploadSpinnerComponent } from '../../../utilities/upload-spinner/upload-spinner.component';
import { UploadProgress } from '../../../viewmodels/apple/apple-upload-progress.model';

@Component({
  selector: 'ml-upload-application-modal',
  templateUrl: './upload-application-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [UploadSpinnerComponent, ReactiveFormsModule, FormsModule, FaIconComponent],
})
export class UploadApplicationModalComponent {
  private readonly appService = inject(AppleApplicationsService);
  private readonly toastService = inject(ToastService);
  public readonly modal = inject(NgbActiveModal);

  public package: File;
  public uploadProgress: UploadProgress = {
    isLoading: false,
    progress: 0,
  };

  public onFileChange(e): void {
    this.package = e.target.files[0];
  }

  public onSubmit(): void {
    this.uploadProgress.isLoading = true;
    this.appService.postApplication(this.package).subscribe({
      next: (progress) => {
        this.uploadProgress.progress = progress ?? 0;
      },
      complete: () => {
        this.uploadProgress.isLoading = false;
        this.uploadProgress.progress = 0;
        this.toastService.showSuccess('Application uploaded successfully');
        this.modal.close();
      },
    });
  }
}
